import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const PickQuestionImport = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <div className="pickquestion-container">

        <div className="settings-header">
      <h1>Question Management</h1>
      <p>Select how you want to create or import questions</p>
    </div>

    
      <div className="settings-grid">
        {/* Question Bank Card */}
        <div 
          className="settings-card" 
          onClick={() => navigate(`/chapter-list/${id}`)}
        >
          <div className="card-icon-wrapper bg-green-100">
            <i className="ph-duotone ph-chalkboard-simple"></i>
          </div>
          <h3>Question Bank</h3>
          <p>Browse and select questions from your bank</p>
          <span className="card-action">Access →</span>
        </div>

        {/* Import Questions Card */}
        <div 
          className="settings-card" 
          onClick={() => navigate(`/import-question`)}
        >
          <div className="card-icon-wrapper bg-blue-100">
            <i className="ph-duotone ph-download-simple"></i>
          </div>
          <h3>Import Questions</h3>
          <p>Import questions from external sources</p>
          <span className="card-action">Import →</span>
        </div>

        {/* Previous Paper Card (Commented) */}
        {/* <div 
          className="settings-card" 
          onClick={() => navigate(`/previous-paper/${id}`)}
        >
          <div className="card-icon-wrapper bg-purple-100">
            <i className="ph-duotone ph-rewind"></i>
          </div>
          <h3>Previous Paper</h3>
          <p>Access previously created papers</p>
          <span className="card-action">View →</span>
        </div> */}

        {/* Generate Random Questions Card */}
        <div 
          className="settings-card" 
          onClick={() => navigate(`/random/${id}`)}
        >
          <div className="card-icon-wrapper bg-amber-100">
            <i className="ph-duotone ph-shuffle"></i>
          </div>
          <h3>Generate Random Questions</h3>
          <p>Create randomized question sets automatically</p>
          <span className="card-action">Generate →</span>
        </div>

        {/* Previous Selected Card (Commented) */}
        {/* <div 
          className="settings-card" 
          onClick={() => navigate("/role")}
        >
          <div className="card-icon-wrapper bg-rose-100">
            <i className="ph-duotone ph-user"></i>
          </div>
          <h3>Previous Selected</h3>
          <p>View previously selected questions</p>
          <span className="card-action">View →</span>
        </div> */}
      </div>

      <style>
        {`
          .pickquestion-container {
            min-height: 90vh;
            background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
            padding: 1.5rem;
          }
          
          .settings-header {
            max-width: 1200px;
            margin: 0 auto 2rem;
            padding: 0 0.75rem;
          }
          
          .settings-header h1 {
            font-size: 2rem;
            font-weight: 700;
            color: #1a202c;
            margin-bottom: 0.5rem;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          
          .settings-header p {
            font-size: 1rem;
            color: #718096;
          }
          
          .settings-grid {
            max-width: 1200px;
            margin: 0 auto;
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
            gap: 1.25rem;
            padding: 0 0.75rem;
          }
          
          .settings-card {
            background: white;
            border-radius: 1rem;
            padding: 1.5rem;
            text-align: center;
            cursor: pointer;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            border: 1px solid #e2e8f0;
            position: relative;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            align-items: center;
            min-height: 180px;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          }
          
          .settings-card::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 3px;
            background: linear-gradient(90deg, #667eea, #764ba2);
            opacity: 0;
            transition: opacity 0.3s;
          }
          
          .settings-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
            border-color: #cbd5e0;
          }
          
          .settings-card:hover::before {
            opacity: 1;
          }
          
          .settings-card:hover .card-action {
            opacity: 1;
            transform: translateX(0);
          }
          
          .card-icon-wrapper {
            width: 60px;
            height: 60px;
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 1rem;
            transition: all 0.3s;
          }
          
          .settings-card:hover .card-icon-wrapper {
            transform: scale(1.08) rotate(3deg);
          }
          
          .card-icon-wrapper i {
            font-size: 1.75rem;
          }
          
          .bg-blue-100 { background-color: #dbeafe; color: #1d4ed8; }
          .bg-purple-100 { background-color: #f3e8ff; color: #7c3aed; }
          .bg-green-100 { background-color: #dcfce7; color: #16a34a; }
          .bg-amber-100 { background-color: #fef3c7; color: #d97706; }
          .bg-rose-100 { background-color: #ffe4e6; color: #e11d48; }
          
          .settings-card h3 {
            font-size: 1.125rem;
            font-weight: 600;
            color: #2d3748;
            margin-bottom: 0.375rem;
          }
          
          .settings-card p {
            font-size: 0.8125rem;
            color: #718096;
            margin-bottom: 0.75rem;
            flex-grow: 1;
            line-height: 1.4;
          }
          
          .card-action {
            font-size: 0.8125rem;
            font-weight: 500;
            color: #4f46e5;
            opacity: 0;
            transform: translateX(-8px);
            transition: all 0.3s;
          }
          
          @media (max-width: 768px) {
            .pickquestion-container {
              padding: 1rem;
            }
            
            .settings-header h1 {
              font-size: 1.75rem;
            }
            
            .settings-header p {
              font-size: 0.9375rem;
            }
            
            .settings-grid {
              grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
              gap: 1rem;
            }
            
            .settings-card {
              padding: 1.25rem;
              min-height: 160px;
            }
            
            .card-icon-wrapper {
              width: 56px;
              height: 56px;
              border-radius: 14px;
            }
            
            .card-icon-wrapper i {
              font-size: 1.5rem;
            }
          }
          
          @media (max-width: 480px) {
            .settings-grid {
              grid-template-columns: 1fr;
              max-width: 280px;
            }
            
            .settings-card {
              min-height: 140px;
              padding: 1rem;
            }
          }
          
          @media (min-width: 768px) and (max-width: 1024px) {
            .settings-grid {
              grid-template-columns: repeat(2, 1fr);
            }
          }
          
          @media (min-width: 1024px) {
            .settings-grid {
              grid-template-columns: repeat(4, 1fr);
            }
          }
        `}
      </style>
    </div>
  );
};

export default PickQuestionImport;